(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-guide-assets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
  const link = event.target.closest('a[data-rr-download]');
  if (event.defaultPrevented) return;
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const section = link.closest('[data-rr-guide-section]');
  if (!section) return;
  event.preventDefault();
  if (link.getAttribute('aria-busy') === 'true') return;
  const box = link.closest('.rr-card, .rr-download-all');
  const status = box.querySelector('.rr-status');
  const original = link.textContent;
  link.setAttribute('aria-busy', 'true');
  link.textContent = section.dataset.downloading;
  status.textContent = '';
  try {
    const response = await fetch(link.href, { credentials: 'omit' });
    if (!response.ok) throw new Error('Download failed');
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = decodeURIComponent(new URL(link.href).pathname.split('/').pop());
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    status.textContent = section.dataset.error + ' ';
    const fallback = document.createElement('a');
    fallback.href = link.href;
    fallback.target = '_blank';
    fallback.rel = 'noopener';
    fallback.className = 'rr-link';
    fallback.textContent = section.dataset.openLabel;
    status.appendChild(fallback);
  } finally {
    link.textContent = original;
    link.removeAttribute('aria-busy');
  }
});

function refreshResinRockGuideNavigation() {
  document.querySelectorAll('[data-rr-guide-nav]').forEach(nav => {
    const scope = nav.closest('main') || document;
    const categories = Array.from(scope.querySelectorAll('[data-rr-guide-category], .rr-specs[id]'));
    nav.replaceChildren(...categories.map(category => {
      const link = document.createElement('a');
      link.href = '#' + category.id;
      link.textContent = category.dataset.rrGuideTitle || category.querySelector('h2')?.textContent || '';
      return link;
    }));
  });
  document.querySelectorAll('main').forEach(scope => {
    scope.querySelectorAll('[data-rr-guide-category]').forEach((category, index) => {
      const number = category.querySelector('[data-rr-guide-number]');
      if (number) number.textContent = String(index + 1).padStart(2, '0');
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshResinRockGuideNavigation);
else refreshResinRockGuideNavigation();
['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => {
  document.addEventListener(name, () => requestAnimationFrame(refreshResinRockGuideNavigation));
});
  } catch(e) { console.error(e); }
})();

})();
